module.exports = __webpack_public_path__ + "21f9c2bbd5a76e4b985da99c56e39760.png";